const styles = (theme) => ({
    root: {
        position: 'absolute',
        bottom: 0,
        height: '100%',
        width: '99%'
    }
})

export default styles